import { transitionBiddingBlockApprovalState } from '@ebalance/proto/bffuser/v1/bidding_block_service-BiddingBlockService_connectquery'

import { blockApprovalRequestInvalidationKeys } from '~/hooks/bidding/queryKeys'
import { useWorkflowCaseScopedMutation } from '~/hooks/bidding/useWorkflowCaseScopedMutation'
import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * ブロック入札 承認ステータス遷移 mutation hook (楽観ロック使用)。
 * action: REQUEST / APPROVE / REJECT / CANCEL / SUBMIT を指定。
 * LINK / LOOP の all-or-nothing は backend usecase が atomic に保証する。
 */
export function useTransitionBiddingBlockApprovalState(): InvalidatingMutationResultFor<
  typeof transitionBiddingBlockApprovalState
> {
  return useWorkflowCaseScopedMutation(
    useInvalidatingMutation(
      transitionBiddingBlockApprovalState,
      blockApprovalRequestInvalidationKeys,
    ),
  )
}
